<div
  class="card"
  *appIsGranted="['VAN_TRANSFER', 'VAN_TRANSFER_DEVICES', 'READ']"
>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-9"><h6>Van Transfer</h6></div>
        <div class="col-md-3">
          <button
            class="btn btn-sm btn-primary pull right ms-3"
            (click)="openModal(modalInserVan)"
          >
            Adicionar
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-2">
          <label>Placa</label>
          <div class="mb-1 row">
            <input
              class="form-control"
              type="text"
              id="plate-input-text"
              placeholder="Placa"
              [(ngModel)]="filterPlate"
            />
          </div>
        </div>
        <div class="col-md-2">
          <label>Status</label>
          <ng-select
            class="w-100 mb-3"
            id="statusSelect"
            placeholder="Selecione um status"
            [(ngModel)]="filterSituation"
          >
            <ng-option value="green"> {{ "<" }} 7 min </ng-option>
            <ng-option value="yellow">
              {{ ">" }} 7 min {{ "<" }} 30 min
            </ng-option>
            <ng-option value="red"> > 1 hora </ng-option>
          </ng-select>
        </div>
        <div class="col-md-4">
          <!-- <label>Localização</label>
          <ng-select
            class="w-100 mb-3"
            id="local"
            placeholder="Selecione um local"
          ><ng-option *ngFor="let local of vanTransferLocal">
             {{local.name}} 
  
           </ng-option>
            <ng-option value="0"> GRU </ng-option>
            <ng-option value="1"> CWB </ng-option> 
          </ng-select> -->
          <label>Localização</label>

          <ng-select
            class="w-100 mb-3"
            id="localSelect"
            placeholder="Selecione um local"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="filterLocation"
          >
            <ng-option
              *ngFor="let local of vanTransferLocal"
              [value]="local.id"
            >
              {{ local.name }}
            </ng-option>
          </ng-select>
        </div>
        <div class="col-md-2">
          <button
            type="submit"
            class="btn btn-sm btn-primary"
            (click)="filter()"
          >
            Filtrar
          </button>
        </div>
        <div class="col-md-2">
          <button
            type="submit"
            class="btn btn-sm btn-danger"
            (click)="filterClear()"
          >
            Limpar Filtro
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Nav tabs -->
      <ul
        ngbNav
        #customNav="ngbNav"
        [activeId]="1"
        class="nav nav-tabs nav-tabs-custom"
      >
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Vans</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabVans"></ng-template>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>
            <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
            <span class="d-none d-sm-block">Mapa</span>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="TabMaps"></ng-template>
          </ng-template>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content p-3 text-muted">
        <div [ngbNavOutlet]="customNav"></div>
      </div>
    </div>
  </div>

  <!-- Dialog Insert Item -->
  <ng-template #modalInserVan let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">Novo Veículo</h5>
        <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-plate">*Placa</span>
        <input
          name="plate"
          [(ngModel)]="newVanTransfer.plate" 
          type="text"
          class="form-control"
          required
          aria-describedby="inputGroup-plate"
        />
        <button
        type="button"
        class="btn btn-sm btn-primary pull right ms-4"
        (click)="getDataByPlate()"
        >Buscar Placa
        </button>
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-model">Modelo </span>
        <input
          name="model"
          [(ngModel)]="newVanTransfer.model"
          type="text"
          maxlength="50"
          class="form-control"
          aria-describedby="inputGroup-model"
          [disabled]="isBlockedModel"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-color">Cor </span>
        <input
          name="color"
          [(ngModel)]="newVanTransfer.color"
          type="text"
          maxlength="50"
          class="form-control"
          aria-describedby="inputGroup-color"
          [disabled]="isBlockedColor"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-local"
          >Dispositivo Instalado
        </span>
        <input
          name="model"
          [(ngModel)]="newVanTransfer.deviceSerial"
          type="text"
          maxlength="50"
          class="form-control"
          aria-describedby="inputGroup-model"
          [disabled]="isBlockedDevice"
        />
      </div>
            <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-local">*Local </span>
        <select
          name="local"
          [(ngModel)]="newVanTransfer.localId"
          type="number"
          class="form-control"
          aria-describedby="inputGroup-model"
        >
          <option *ngFor="let local of vanTransferLocal" [value]="local.id">
            {{ local.name }}
          </option>
        </select>
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-description"
          >Descrição</span
        >
        <div class="form-horizontal w-100">
          <div class="form-group">
            <textarea
              name="description"
              [(ngModel)]="newVanTransfer.description"
              maxlength="250"
              class="form-control"
              rows="5"
            ></textarea>
          </div>
        </div>
      </div>
      <button
        *appIsGranted="['VAN_TRANSFER', 'VAN_TRANSFER_DEVICES', 'CREATE']"
        type="submit"
        class="btn btn-primary"
        [disabled]="
          newVanTransfer.plate.length < 1 ||
          plates.indexOf(newVanTransfer.plate.replace('-', '')) > -1
        "
        (click)="
          insertNewVanTransfer();
          modal.dismiss('Cross click') ||
            newVanTransfer.localId == -1 ||
            newVanTransfer.localId == null
        "
      >
        Criar
      </button>
      <label *ngIf="newVanTransfer.plate.length < 1" class="text-danger ms-3">
        Preencha a placa</label
      >
      <label
        *ngIf="
          plates.indexOf(
            newVanTransfer.plate.toLocaleLowerCase().replace('-', '')
          ) > -1
        "
        class="text-danger ms-3"
      >
        Placa já existente</label
      >
      <label
        *ngIf="newVanTransfer.localId == -1 || newVanTransfer.localId == null"
        class="text-danger ms-3"
      >
        Preencha o local</label
      >
    </div>
  </ng-template>

  <!-- Dialog Update Item -->
  <ng-template #modalUpdateSerial let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">Editar veículo</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-plate">*Placa</span>
        <input
          name="plate"
          [(ngModel)]="updateVanTransferItem.plate"
          type="text"
          class="form-control"
          required
          [disabled]="true"
          aria-describedby="inputGroup-plate"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-model">Modelo </span>
        <input
          name="model"
          [(ngModel)]="updateVanTransferItem.model"
          type="text"
          maxlength="50"
          class="form-control"
          aria-describedby="inputGroup-model"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-color">Cor </span>
        <input
          name="color"
          [(ngModel)]="updateVanTransferItem.color"
          type="text"
          maxlength="50"
          class="form-control"
          aria-describedby="inputGroup-color"
        />
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-local">*Local </span>
        <select
          name="local"
          [(ngModel)]="updateVanTransferItem.localId"
          type="number"
          class="form-control"
          aria-describedby="inputGroup-model"
        >
          <option *ngFor="let local of vanTransferLocal" [value]="local.id">
            {{ local.name }}
          </option>
        </select>
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-local"
          >Dispositivo Instalado
        </span>
        <select
          [(ngModel)]="updateVanTransferItem.deviceSerial"
          class="form-control"
          aria-describedby="inputGroup-model"
          [multiple]="true"
        >
          <option *ngFor="let serial of deviceSerialUpdate">
            {{ serial }}
          </option>
        </select>
      </div>
      <div class="mb-3">
        <button
          class="btn btn-primary"
          (click)="openModalSmall(modalNewSerial)"
        >
          Adicionar novo serial
        </button>
      </div>
      <div class="input-group input-group-sm mb-3">
        <span class="input-group-text" id="inputGroup-description"
          >Descrição</span
        >
        <div class="form-horizontal w-100">
          <div class="form-group">
            <textarea
              name="model"
              [(ngModel)]="updateVanTransferItem.description"
              maxlength="250"
              class="form-control"
              rows="5"
            ></textarea>
          </div>
        </div>
      </div>
      <div>
        <span>
          Criado por: {{ updateVanTransferItem.userCreateName }} -
          {{ updateVanTransferItem.createDate }}
        </span>
      </div>
      <div>
        <span>
          Modificado por: {{ updateVanTransferItem.userCreateName }} -
          {{ updateVanTransferItem.createDate }}
        </span>
      </div>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="
          updateVanTransferItem.plate.length < 1 ||
          (plates.indexOf(updateVanTransferItem.plate) > -1 &&
            serialAuxUpdate.toLocaleLowerCase().replace('-', '') !=
              updateVanTransferItem.plate
                .toLocaleLowerCase()
                .replace('-', '')) ||
          updateVanTransferItem.localId == -1 ||
          updateVanTransferItem.localId == null
        "
        (click)="
          updateItem(updateVanTransferItem, updateVanTransferItem.plate);
          modal.dismiss('Cross click')
        "
      >
        Salvar
      </button>
      <label
        *ngIf="updateVanTransferItem.plate.length < 1"
        class="text-danger ms-3"
      >
        Preencha a placa</label
      >
      <label
        *ngIf="
          plates.indexOf(updateVanTransferItem.plate.replace('-', '')) > -1 &&
          serialAuxUpdate.toLocaleLowerCase().replace('-', '') !=
            updateVanTransferItem.plate.toLocaleLowerCase().replace('-', '')
        "
        class="text-danger ms-3"
      >
        Placa já existente</label
      >
      <label
        *ngIf="
          updateVanTransferItem.localId == -1 ||
          updateVanTransferItem.localId == null
        "
        class="text-danger ms-3"
      >
        Preencha o local
      </label>
    </div>
  </ng-template>

  <!-- Dialog New serial -->
  <ng-template #modalNewSerial let-modal>
    <div class="modal-header">
      <h5 class="modal-title mt-0">Novo dispositivo</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="modal-body">
        <div class="input-group input-group-sm mb-3">
          <span class="input-group-text" id="inputGroup-plate"
            >Dispositivo</span
          >
          <input
            #deviceNewSerial
            name="serialNew"
            id="serialNew"
            class="form-control"
            required
            aria-describedby="inputGroup-plate"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-sm btn-primary"
          type="submit"
          (click)="
            deviceNewSerial.value.length > 0
              ? addDeviceSerialUpdate(deviceNewSerial.value)
              : null;
            modal.dismiss('Cross click')
          "
        >
          Inserir
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Tab Vans-->
  <ng-template #TabVans>
    <table class="table table-fit table-bordered table-hover mb-3">
      <thead class="table-primary">
        <tr>
          <th scope="col">Localização</th>
          <th scope="col">Rota</th>
          <th scope="col">Placas</th>
        </tr>
      </thead>
      <tbody class="overflow-auto">
        <tr *ngFor="let item of routes; let i = index">
          <td class="col-md-1 user-select-all" scope="row">
            {{ returnLocal(item.localId) }}
          </td>
          <td class="col-md-1 user-select-all" scope="row">
            {{ item.name }}
          </td>
          <td class="col-md-1" scope="row">
            <div
              class="m-1 badge badge-soft-primary py-2"
              [ngStyle]="{
                'border-bottom': 'ridge',
                'border-bottom-color': returnColorStatusPlate(itemPlate)
              }"
              [ngbTooltip]="returnColorStatusPlateTooltip(itemPlate)"
              placement="auto"
              *ngFor="let itemPlate of item.plates?.split(',')"
            >
              {{ itemPlate }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table table-fit table-bordered table-hover">
      <thead class="table-primary">
        <tr>
          <th scope="col">Localização</th>
          <th scope="col">Rota</th>
          <th scope="col">Placa</th>
          <th scope="col">Modelo</th>
          <th scope="col">Dispositivo Instalado</th>
          <th scope="col">Status</th>
          <th scope="col">Descrição</th>
          <th scope="col">Ação</th>
        </tr>
      </thead>
      <tbody class="overflow-auto">
        <tr *ngFor="let item of vanTransfer; let i = index">
          <td class="col-md-1 user-select-all" scope="row">
            {{ returnLocal(item.localId) }}
          </td>
          <td
            class="col-md-3"
            [ngStyle]="{
              overflow: i == vanTransfer.length - 1 ? 'auto' : ''
            }"
          >
            <ng-select
              (change)="changeVanTransferRoute(item)"
              placeholder="Selecione uma rota"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="item.routes_id"
            >
              <ng-option value="null">Fora de Operação</ng-option>
              <ng-option
                *ngFor="let route of filterRoute(routes, item.localId)"
                [value]="returnRouteIdString(route.id)"
              >
                {{ route.name }}
              </ng-option>
            </ng-select>
          </td>
          <td class="col-md-1 user-select-all" scope="row">
            {{ item.plate }}
          </td>
          <td class="col-md-2 user-select-all" scope="row">
            {{ item.model == "null" ? "" : item.model }}
          </td>
          <td class="col-md-2 user-select-all" scope="row">
            {{ item.deviceSerial }}
          </td>
          <td class="col-md-1 user-select-all" scope="row">
            <button
              type="button"
              class="btn"
              [ngStyle]="{
                'background-color': returnColorStatusSerial(
                  item.deviceSerialLastPositionHTML
                    ? item.deviceSerialLastPositionHTML
                    : ''
                )
              }"
              [ngbTooltip]="
                returnColorTooltipSerial(
                  item.deviceSerialLastPositionHTML
                    ? item.deviceSerialLastPositionHTML
                    : ''
                )
              "
              placement="auto"
            ></button>
          </td>
          <td class="col-md-2 user-select-all" scope="row">
            {{ item.description == "null" ? "" : item.description }}
          </td>
          <td class="no-wrap" scope="row">
            <div class="d-inline">
              <i-feather
                *appIsGranted="[
                  'VAN_TRANSFER',
                  'VAN_TRANSFER_DEVICES',
                  'UPDATE'
                ]"
                class="card"
                ngbTooltip="Editar"
                name="edit"
                style="color: blue; cursor: pointer"
                (click)="openModalUpdate(item, modalUpdateSerial)"
              >
              </i-feather>
              <i-feather
                *appIsGranted="[
                  'VAN_TRANSFER',
                  'VAN_TRANSFER_DEVICES',
                  'UPDATE'
                ]"
                class="card"
                ngbTooltip="Inativar"
                name="x-circle"
                style="color: rgb(255, 102, 0); cursor: pointer"
                (click)="inactiveVanTransfer(item.plate)"
                >
              </i-feather>
              <i-feather
                *appIsGranted="[
                  'VAN_TRANSFER',
                  'VAN_TRANSFER_DEVICES',
                  'UPDATE'
                ]"
                class="card"
                ngbTooltip="Deletar"
                name="trash-2"
                style="color: red; cursor: pointer"
                (click)="daleteVanTransfer(item.plate)"
                >
              </i-feather>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-template>

  <!-- Tab Maps -->
  <ng-template #TabMaps>
    <div class="row" [fluidHeight]>
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <button class="btn btn-sm btn-primary" (click)="searchLastPosition()">
          Pesquisar
        </button>
      </div>
    </div>

    <div id="map"></div>
  </ng-template>
</div>
